import { Component, OnInit, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidationErrors,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResigteringService } from '../auth/resigtering.service';
import Swal from 'sweetalert2';
import { IRegisterInterface } from '../../../interfaces/registerInterface';
import { LoginService } from '../auth/login.service';
import { UserService } from '../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';
import { DeviceDetectorService } from '../../../services/device-detector.service';
import { ItemsService } from '../../../services/items.service';
import { WarehouseTypeService } from '../../../services/warehouse-type';


@Component({
  selector: 'app-resigtering',
  templateUrl: './resigtering.component.html',
  styleUrl: './resigtering.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ResigteringComponent implements OnInit {
  data!: FormGroup;
  contentReady: boolean = false;
  userInfo: any;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  imageSrc: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;
  mediaFiles!: any;
  media!: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  warehouses!: any;
  warehouseId!: any;
  defaultImage: string = '/assets/card photo.png';
  type = [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Affiliation' },
    { id: 3, name: 'Page A' },
    { id: 4, name: 'Page B' },
    { id: 5, name: 'Page C' },
    { id: 6, name: 'Sub Admin' },
  ];
  formInfo = new FormGroup({
    name: new FormControl(''),
    sname: new FormControl(''),
    username: new FormControl(''),
    instagram: new FormControl(''),
    facebook: new FormControl(''),
    tiktok: new FormControl(''),
    phone: new FormControl(''),
    type: new FormControl(''),
    password: new FormControl(''),
    c_Password: new FormControl(''),
    media: new FormControl(''),
  });
  registerRequest: IRegisterInterface = {} as IRegisterInterface;
  errorExit: boolean = false;
  newUserEmail: string = '';
  accounttype: string = '';
  isUpdatePage: boolean = false;
  editedUserId!: any;
  first_name!: any;
  username!: any;
  last_name!: any;
  instagram_link!: any;
  facebook_link!: any;
  tiktok_link!: any;
  phone!: any;
  image!: any;
  read_password!: any;
  isAdmin!: boolean;
  isSuperAdmin!: boolean;
  isAffiliationSelected: boolean = false;
  accessPagesList = [
    { value: 0, label: 'employees' },
    { value: 1, label: 'financial' },
    { value: 2, label: 'myclients' },
    { value: 3, label: 'delivery' },
    { value: 4, label: 'supplies' },
    { value: 5, label: 'Orders' },
    { value: 6, label: 'Stock' },
    { value: 7, label: 'Pospage' }
  ];

  // ✅ القيم المختارة
  accessPages: number[] = [7];
  submitted = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _ResigteringService: ResigteringService,
    private _Router: Router,
    private deviceService: DeviceDetectorService,
    private _ItemsService: ItemsService,
    public warehouseTypeService: WarehouseTypeService,
    private route: ActivatedRoute,
    private _userService: UserService
  ) { }
  validateAreEqual(pass: string, c_Pass: string) {
    return (group: AbstractControl): ValidationErrors | null => {
      const formGroup = group as FormGroup;
      const password = formGroup.controls[pass];
      const c_Password = formGroup.controls[c_Pass];
      const errors = { ...(c_Password.errors || {}) };

      if (password.value !== c_Password.value) {
        c_Password.setErrors({ ...errors, passwordMismatch: true });
      } else {
        delete errors['passwordMismatch'];
        c_Password.setErrors(Object.keys(errors).length ? errors : null);
      }

      return null;
    };
  }
  private updateAccessPagesByType(typeValue: any) {
    const selectedType = Number(typeValue);

    if (selectedType === 2) {
      // Affiliation
      this.isAffiliationSelected = true;
      this.accessPages = [1, 2, 5, 6, 7];
    } else {
      this.isAffiliationSelected = false;

      // خليك ضامن إن Pospage موجود دايمًا
      if (!this.accessPages.includes(7)) {
        this.accessPages.push(7);
      }
    }
  }
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.warehouseId = localStorage.getItem("posId");
    this.checkAccountType();

    this.formInfo = this._formBuilder.group(
      {
        name: [
          '',
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(60),
            Validators.pattern('[a-zA-Z\u0600-\u06FF ]*')
          ],
        ],
        sname: [
          '',
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(60),
            Validators.pattern('[a-zA-Z\u0600-\u06FF ]*')
          ],
        ],
        facebook: [''],
        instagram: [''],
        tiktok: [''],
        media: [''],
        username: ['', [Validators.required]],
        phone: [
          '',
          [
            Validators.required,
            this.realEgyptOrKsaPhoneValidator
          ],
        ],
        type: ['', [Validators.required]],
        password: [
          '',
          [
            Validators.required,
            Validators.maxLength(40),
            Validators.minLength(8),
          ],
        ],
        c_Password: ['', [Validators.required]]
      },
      { validator: this.validateAreEqual('password', 'c_Password') }
    );

    this.formInfo.get('type')?.valueChanges.subscribe((value) => {
      this.updateAccessPagesByType(value);
    });

    this.route.queryParams.subscribe(params => {
      if (params["id"] != null) {
        this.isUpdatePage = true;
      }

      this.editedUserId = params["id"];
      this.first_name = params["first_name"];
      this.username = params["username"];
      this.last_name = params["last_name"];
      this.instagram_link = params["instagram_link"];
      this.facebook_link = params["facebook_link"];
      this.tiktok_link = params["tiktok_link"];
      this.phone = params["phone"];
      this.image = params["image"];
      this.read_password = params["read_password"];

      const selectedType = params["type"];

      this.accessPages = params['access_pages']
        ? Array.isArray(params['access_pages'])
          ? params['access_pages'].map(Number)
          : JSON.parse(params['access_pages'])
        : [];

      if (!this.accessPages.includes(7)) {
        this.accessPages.push(7);
      }

      if (selectedType) {
        this.formInfo.get('type')?.setValue(selectedType);
        this.updateAccessPagesByType(selectedType);
      }
    });
  }

  realEgyptOrKsaPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const rawValue = String(control.value).trim();
    const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
    if (arabicRegex.test(rawValue)) {
      return { arabicNotAllowed: true };
    }

    const phone = rawValue.replace(/[\s\-()]/g, '');
    const egyptMobileRegex = /^(01[0125]\d{8}|\+201[0125]\d{8}|00201[0125]\d{8})$/;
    const ksaMobileRegex = /^(05\d{8}|\+9665\d{8}|009665\d{8})$/;

    return egyptMobileRegex.test(phone) || ksaMobileRegex.test(phone)
      ? null
      : { invalidEgyptOrKsaPhone: true };
  };

  shouldShowError(controlName: string): boolean {
    const control = this.formInfo?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.formInfo?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    if (control.errors['minlength']) {
      const requiredLength = control.errors['minlength'].requiredLength;
      return this.isAr
        ? `${label} لازم يكون ${requiredLength} حروف على الأقل`
        : `${label} must be at least ${requiredLength} characters`;
    }

    if (control.errors['maxlength']) {
      const requiredLength = control.errors['maxlength'].requiredLength;
      return this.isAr
        ? `${label} لازم يكون ${requiredLength} حروف أو أقل`
        : `${label} must be ${requiredLength} characters or less`;
    }

    if (control.errors['pattern']) {
      return this.isAr
        ? `${label} لازم يحتوي على حروف فقط`
        : `${label} must contain letters only`;
    }

    if (control.errors['invalidEgyptOrKsaPhone']) {
      return this.isAr
        ? `${label} لازم يكون رقم موبايل مصري أو سعودي صحيح`
        : `${label} must be a valid Egyptian or Saudi mobile number`;
    }

    if (control.errors['arabicNotAllowed']) {
      return this.isAr
        ? `${label} لازم يكون بأرقام إنجليزية بدون حروف عربية`
        : `${label} must use English digits without Arabic characters`;
    }

    if (control.errors['passwordMismatch']) {
      return this.isAr
        ? 'تأكيد كلمة السر لازم يطابق كلمة السر'
        : 'Confirm password must match password';
    }

    return this.isAr ? `${label} غير صحيح` : `${label} is invalid`;
  }

  getMissingRequiredCount(): number {
    if (!this.formInfo) {
      return 0;
    }

    return Object.keys(this.formInfo.controls).filter((controlName) => {
      const control = this.formInfo.get(controlName);
      return control?.hasError('required');
    }).length;
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;

    if (this.formInfo.invalid) {
      this.formInfo.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من بيانات المستخدم' : 'Please check user data',
        text: this.isAr ? 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة' : 'Review the messages below the required or invalid fields',
        confirmButtonText: this.isAr ? 'تمام' : 'OK',
      });

      return false;
    }

    return true;
  }

  onCheckboxChange(event: any) {
    if (this.isAffiliationSelected) return;
    const value = +event.target.value;

    if (value === 7) return; // 🔒 ممنوع يتغير

    if (event.target.checked) {
      if (!this.accessPages.includes(value)) {
        this.accessPages.push(value);
      }
    } else {
      this.accessPages = this.accessPages.filter(v => v !== value);
    }
  }
  fixImgUrl(url: any) {
    return "https://backendproduction.blueboxpet.com/" + url
  }
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }
  checkAccountType() {
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accounttype = data['user_type'];
        this.isAdmin = this.accounttype === '1' || this.accounttype === '10';
        this.isSuperAdmin = this.accounttype === '10';
      },
      error: (error) => console.error(error),
    });
    return this.accounttype;
  }
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.mediaFiles = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.media = e.target.result;
      };
      const url: string = URL.createObjectURL(file);

      reader.readAsDataURL(file);

    }
    console.log(this.mediaFiles)
  }
  saveEmail(e: string) {
    sessionStorage.setItem('email', e);
  }
  password: string = '';
  isPasswordVisible: boolean = false;
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  onSubmit() {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;

    const selectedGender = this.formInfo.value.type;
    const fv = this.formInfo.value;
    const formData = new FormData();
    formData.append('first_name', fv.name?.toString() ?? '');
    formData.append('last_name', fv.sname?.toString() ?? '');
    formData.append('instagram_link', fv.instagram?.toString() ?? '');
    formData.append('facebook_link', fv.facebook?.toString() ?? '');
    formData.append('tiktok_link', fv.tiktok?.toString() ?? '');
    formData.append('username', fv.username?.toString() ?? '');
    formData.append('password', fv.password?.toString() ?? '');
    formData.append('password_confirmation', fv.c_Password?.toString() ?? '');
    formData.append('phone', fv.phone?.toString() ?? '');
    formData.append('warehouse_id',  this.warehouseId);
    formData.append('type', selectedGender?.toString() ?? '');
    this.accessPages.forEach((page: number, index: number) => {
      formData.append(`access_pages[${index}]`, page.toString());
    });

    if (this.mediaFiles) {
      formData.append('image', this.mediaFiles, this.mediaFiles.name); // Add image file to FormData
    }

    if (this.isUpdatePage) {
      this._ResigteringService.editUser(this.editedUserId, formData).subscribe({
        next: (res) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم انشاء الحساب" : 'user added successfully',
            showConfirmButton: false,
            timer: 1500,
          });

          const fv = this.formInfo.value!;

          if (this.isMobile)
            this._Router.navigate(['/allusers.mobile']);
          else
            this._Router.navigate(['/allusers']);
        },
        error: (err) => {
          this.contentReady = false;

          Swal.fire({
            icon: 'error',
            title: this.isAr ? "  حصل مشكلة في انشاء المستخدم " : 'error while adding this user',
            text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.errorExit = true;
        },
      });
    }
    else {

      // Send the form data to the service
      this._ResigteringService.user_Resigter(formData).subscribe({
        next: (res) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم انشاء الحساب" : 'user added successfully',
            showConfirmButton: false,
            timer: 1500,
          });

          const fv = this.formInfo.value!;

          if (this.isMobile)
            this._Router.navigate(['/allusers.mobile']);
          else
            this._Router.navigate(['/allusers']);
        },
        error: (err) => {
          this.contentReady = false;

          Swal.fire({
            icon: 'error',
            title: this.isAr ? "  حصل مشكلة في انشاء المستخدم " : 'error while adding this user',
            text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.errorExit = true;
        },
      });
    }
  }
  private decodeToken(token: string) {
    return JSON.parse(atob(token.split('.')[1]));
  }

}
